import { User } from '../api'

export default (user: User) => {
  if (!user) return ''

  const { account, personal } = user

  if (account.active) {
    const { name, surname } = personal

    return `${name} ${surname}`
  }

  return account.email
}



// WEBPACK FOOTER //
// ./src/project-utils/get-available-username.ts